import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/Pageheader";
import Footer from "../Components/Footer";
import Sidebar from "../Components/Sidebar";
import { Link } from "react-router-dom";
import Addressdata from "../Components/Addressdata";
import Pagination from "../Components/Pagination";


function Myaddress() {
	const cardData = [
		{
			id: 1,
			type: "Home",
			checked: true,
			address:
				"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididu.",
			city: "Washington, Texas",
			zip: "98765",
		},
		{
			id: 2,
			type: "Office",
			checked: false,
			address:
				"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididu.",
			city: "Washington, Texas",
			zip: "98765",
		},
	];

	const [selectedId, setSelectedId] = useState(cardData[0].id);

	const handleRadioChange = (id) => {
		setSelectedId(id);
	};
	const [currentPage, setCurrentPage] = useState(1);
	const totalPages = 10; // Replace with the actual total number of pages

	const handlePageChange = (pageNumber) => {
		setCurrentPage(pageNumber);
		// You can fetch data for the new page here
	};

	return (
		<>
			<Header />
			<PageHeader pagename="My Address" />

			{/* My address Section */}
			<section className="profile-sec">
				<div className="container">
					<div className="row">
						<div className="col-md-3">
							<Sidebar />
						</div>

						<div className="col-md-9">
							<div className="my-info-dv">
								<div className="row">
									<div className="col-md-6">
										<div className="my-info-head">
											<h3 className="primary-color">My Addresses</h3>
										</div>
									</div>
									<div className="col-md-6">
										<div className="edit-profile-dv">
											<Link to="/add-address">
												<button className="btn-all" style={{ width: "50%" }}>
													Add New Address
												</button>
											</Link>
										</div>
									</div>
									<div className="col-md-12">
										<div className="info-border"></div>
									</div>
									<div className="col-md-12">
										<div className="row mt-4 p-4">
											{cardData.map((card) => (
												<div className="col-lg-6" key={card.id}>
													<Addressdata
														id={card.id}
														type={card.type}
														checked={card.id === selectedId}
														onChange={handleRadioChange}
														address={card.address}
														city={card.city}
														zip={card.zip}
													/>
												</div>
											))}
										</div>
									</div>
									<div className="col-lg-12">
										<div>
											{/* Your data rendering code */}
											<div>{/* Render your data here */}</div>

											{/* Render pagination */}
											{/* <Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={handlePageChange}
											/> */}
											  <Pagination />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* ======================= */}

			<Footer />
		</>
	);
}

export default Myaddress;
